/* eslint-disable */
import { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import SubHeader from '../../Components/SubHeader/SubHeader';
import analyticsTypeConstant from '../../Constants/analyticsType.contants';
import { getDateFilterString } from '../../Helpers';
import INVAnalysisListPage from './INVAnalysisListPage';
import styles from './PastINVAnalysisHistoryPage.module.scss';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import { notificationServices } from '@/Services';

const ANALYTICS_TYPE = analyticsTypeConstant.INV_ANALYTICS_LIST_DATA;
const PastINVAnalysisHistoryPage = (props) => {
	const { breadcrumbs, DATE_FILTER } = props;
	const [data, setData] = useState([]);

	const fetchData = async (dateFilter) => {
		const notificationId = notificationServices.generateNotification({
			type: 'Loading',
			message: 'Loading Inventory Analysis History',
		});
		try {
			const payload = {};
			if (dateFilter?.year) {
				let dateString = `${dateFilter.year}`;
				let monthFormat = 'MMMM';

				if (dateFilter.month) {
					dateString += `-${dateFilter.month}`;
					if (dateFilter.month.length === 3) {
						monthFormat = 'MMM';
					}

					if (dateFilter.day) {
						dateString += `-${dateFilter.day}`;
					} else {
						dateString += '-01';
					}
				} else {
					dateString += '-Jan-01';
					monthFormat = 'MMM';
				}

				const formattedDate = moment(dateString, `YYYY-${monthFormat}-DD`).format(
					'YYYY-MM-DD'
				);

				payload.dateRangeFilter = {
					from: formattedDate,
					to: formattedDate,
				};
			}

			const response = await inventoryAnalyticsServices.dayWiseSkuTrail({
				data: payload,
			});
			if (response?.responseCode === 'SS-001') {
				setData(response?.data);
				notificationServices.generateNotification({
					type: 'Success',
					message: 'Inventory Analysis History Fetched Successfully',
					config: { id: notificationId },
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('error', error);
		} finally {
			notificationServices.closeNotification(notificationId);
		}
	};

	useEffect(() => {
		fetchData(DATE_FILTER);
	}, [DATE_FILTER]);

	const selectedDateString = useMemo(() => {
		return getDateFilterString(DATE_FILTER);
	}, [DATE_FILTER]);

	return (
		<div className={styles.root}>
			<SubHeader
				breadcrumbs={breadcrumbs}
				showBreadcrumbs
				selectedDateString={selectedDateString}
			/>
			<INVAnalysisListPage
				data={data}
				ANALYTICS_TYPE={ANALYTICS_TYPE}
			/>
		</div>
	);
};
const mapStateToProps = (state) => {
	const { DATE_FILTER } = state.analytics;
	return {
		DATE_FILTER: DATE_FILTER.selection,
	};
};
const mapDispatchToProps = {};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PastINVAnalysisHistoryPage);
